export default class CreateDomainRequest {
  public name: string = ''
}
